import React, {useEffect} from 'react';
import {setupIonicReact, IonApp, IonRouterOutlet, IonLoading} from '@ionic/react';
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/additional.css';
import './theme/common-style.css';
import {useDispatch,useSelector} from "react-redux";
import {actionToConnectSocketServer, actionToGetUserSessionData} from "./redux/CommonAction";
import {IonReactRouter} from "@ionic/react-router";
import {Redirect, Route} from "react-router";
import LoginPage from "./pages/LoginPage";
import WithoutLoginHomePage from "./pages/WithoutLoginHomePage";
import DashboardPage from "./pages/DashboardPage";
import SettingPage from "./pages/SettingPage";
import CommissionAndChargePage from "./pages/CommissionAndChargePage";
import ComplaintPage from "./pages/ComplaintPage";
import MoneyRequestPage from "./pages/MoneyRequestPage";
import PendingRefundsPage from "./pages/PendingRefundsPage";
import ManageFundsPage from "./pages/ManageFundsPage";
import ReportsPage from "./pages/ReportsPage";
import BusinessSummeryPage from "./pages/BusinessSummeryPage";
import StatementsPage from "./pages/StatementsPage";


// Distributor Pages
import DistributorDashboardPage from "./pages/DistributorDashboardPage";
import DisCreateRetailer from "./components/Distributor/DisCreateRetailer";
import DistributorAgentDetail from "./pages/DistributorAgentDetail";
import DistributorAgentRequestOnOff from "./pages/DistributorAgentRequestOnOff";
import DistManageFundCredit from "./pages/DistManageFundCredit";
import DistManageFundWithdraw from "./pages/DistManageFundWithdraw";
import DistributorRetailerDetail from "./pages/DistributorRetailerDetail";
import DistributorAgentReport from "./pages/DistributorAgentReport";
import AgentManageFund from "./pages/AgentManageFund";

// MD Pages
import MdDashboard from "./pages/MdDashboard";
import MDBusinessSummeryPage from "./pages/MDBusinessSummeryPage";
import MdDistributorCreateUser from "./components/MdDashboard/MdDistributorCreateUser";

import MdDistributorDetails from "./pages/MdDistributorDetails";
import MasterRetailerList from "./pages/MasterRetailerList";
import MasterManageFund from "./pages/MasterManageFund";
import MasterMoneyRequest from "./pages/MasterMoneyRequest";
import MasterManageFundWithdraw from "./pages/MasterManageFundWithdraw";
import MasterQrReport from "./pages/MasterQrReport";
import MasterPgReport from "./pages/MasterPgReport";
import MasterAccountStatements from "./pages/MasterAccountStatements";
import MasterDistributorStatements from "./pages/MasterDistributorStatements";
import MasterCommissionStatements from "./pages/MasterCommissionStatements";
import MasterUserMoneyTrans from "./pages/MasterUserMoneyTrans";
import MasterRechargeUtility from "./pages/MasterRechargeUtility";
import MasterCreditCard from "./pages/MasterCreditCard";
import MasterCreditDebitReport from "./pages/MasterCreditDebitReport";
import MasterAepsTransaction from "./pages/MasterAepsTransaction";
import MasterAepsStatement from "./pages/MasterAepsStatement";
import UserTransactionDetails from "./pages/UserTransactionDetails";
import './css/common.css';

setupIonicReact();

// Define one router for each role
const SuperAdminRoutes = () => (
    <IonReactRouter>
        <IonRouterOutlet>
            <Route path="/dashboard-home" component={DashboardPage}/>
            <Route path="/dashboard-business-summery" component={BusinessSummeryPage}/>
            <Route path="/dashboard-reports" component={ReportsPage}/>
            <Route path="/dashboard-manage-funds" component={ManageFundsPage}/>
            <Route path="/dashboard-pending-refunds" component={PendingRefundsPage}/>
            <Route path="/dashboard-money-request" component={MoneyRequestPage}/>
            <Route path="/dashboard-statements" component={StatementsPage}/>
            <Route path="/dashboard-complaint" component={ComplaintPage}/>
            <Route path="/dashboard-commission-and-charge" component={CommissionAndChargePage}/>
            <Route path="/dashboard-setting" component={SettingPage}/>
            <Redirect exact from="/" to="/dashboard-home" />
            <Route render={() => <Redirect to="/dashboard-home" />} />
        </IonRouterOutlet>
    </IonReactRouter>
);

const MasterDistributorRoutes = () => (
    <IonReactRouter>
        <IonRouterOutlet>
            <Route path="/md-dashboard" component={MdDashboard}/>
            <Route path="/md-business-summery" component={MDBusinessSummeryPage}/>
            <Route path="/md-distributor-details" component={MdDistributorDetails}/>
            <Route path="/mastercreateuser/" component={MdDistributorCreateUser}/>
            <Route path="/master-retailer-list" component={MasterRetailerList}/>
            <Route path="/master-manage-fund" component={MasterManageFund}/>
            <Route path="/master-managefund-withdraw" component={MasterManageFundWithdraw}/>
            <Route path="/master-money-request" component={MasterMoneyRequest}/>
            <Route path="/master-qr-report" component={MasterQrReport}/>
            <Route path="/master-pg-report" component={MasterPgReport}/>
            <Route path="/master-account-statements" component={MasterAccountStatements}/>
            <Route path="/master-distributor-statements" component={MasterDistributorStatements}/>
            <Route path="/master-commission-statements" component={MasterCommissionStatements}/>
            <Route path="/master-usermoney-transaction" component={MasterUserMoneyTrans}/>
            <Route path="/master-recharge-utility" component={MasterRechargeUtility}/>
            <Route path="/master-credit-card" component={MasterCreditCard}/>
            <Route path="/master-creditdebit-report" component={MasterCreditDebitReport}/>
            <Route path="/master-aeps-transaction" component={MasterAepsTransaction}/>
            <Route path="/master-aeps-statement" component={MasterAepsStatement}/>
            <Route path="/master-user-transaction" component={UserTransactionDetails}/>
            <Route path="/dashboard-setting" component={SettingPage}/>
            <Redirect exact from="/" to="/md-dashboard" />
            <Route render={() => <Redirect to="/md-dashboard" />} />
        </IonRouterOutlet>
    </IonReactRouter>
);

const LocalDistributorRoutes = () => (
    <IonReactRouter>
        <IonRouterOutlet>
            <Route path="/distributor-dashboard" component={DistributorDashboardPage}/>
            <Route path="/md-business-summery" component={MDBusinessSummeryPage}/>
            <Route path="/discrateretailer" component={DisCreateRetailer}/>
            <Route path="/distributor-agent-detail" component={DistributorAgentDetail}/>
            <Route path="/disretailer-details" component={DistributorRetailerDetail}/>
            <Route path="/distributoragent-request-onoff" component={DistributorAgentRequestOnOff}/>
            <Route path="/dist-managefund-credit" component={DistManageFundCredit}/>
            <Route path="/dist-managefund-withdraw" component={DistManageFundWithdraw}/>
            <Route path="/master-money-request" component={MasterMoneyRequest}/>
            <Route path="/master-qr-report" component={MasterQrReport}/>
            {/*<Route path="/master-pg-report" component={MasterPgReport}/>*/}
            <Route path="/master-account-statements" component={MasterAccountStatements}/>
            <Route path="/master-commission-statements" component={MasterCommissionStatements}/>

            <Route path="/dashboard-money-request" component={MoneyRequestPage}/>
            <Route path="/dashboard-statements" component={StatementsPage}/>
            <Route path="/dashboard-business-summery" component={BusinessSummeryPage}/>
            <Route path="/distributor-agent-report" component={DistributorAgentReport}/>
            <Route path="/agent-manage-fund" component={AgentManageFund}/>
            <Route path="/dashboard-reports" component={ReportsPage}/>
            <Route path="/dashboard-setting" component={SettingPage}/>
            <Redirect exact from="/" to="/distributor-dashboard" />
            <Route render={() => <Redirect to="/distributor-dashboard" />} />
        </IonRouterOutlet>
    </IonReactRouter>
);

const RetailerRoutes = () => (
    <IonReactRouter>
        <IonRouterOutlet>
            <Route path="/dashboard-home" component={DashboardPage}/>
            <Route path="/dashboard-business-summery" component={BusinessSummeryPage}/>
            <Route path="/dashboard-reports" component={ReportsPage}/>
            <Route path="/dashboard-manage-funds" component={ManageFundsPage}/>
            <Route path="/dashboard-pending-refunds" component={PendingRefundsPage}/>
            <Route path="/dashboard-money-request" component={MoneyRequestPage}/>
            <Route path="/dashboard-statements" component={StatementsPage}/>
            <Route path="/dashboard-complaint" component={ComplaintPage}/>
            <Route path="/dashboard-commission-and-charge" component={CommissionAndChargePage}/>
            <Route path="/dashboard-setting" component={SettingPage}/>
            <Redirect exact from="/" to="/dashboard-home" />
            <Route render={() => <Redirect to="/dashboard-home" />} />
        </IonRouterOutlet>
    </IonReactRouter>
);


// Main Component
const AppEnterMainPage = () => {
    const { userInfo } = useSelector((state) => state.userAuthDetail);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actionToConnectSocketServer());
    }, [dispatch]);

    if (!userInfo) return null; // Prevent rendering before userInfo is loaded

    switch (userInfo.role) {
        case 1:
            return <SuperAdminRoutes />;
        case 2:
            return <MasterDistributorRoutes />;
        case 3:
            return <LocalDistributorRoutes />;
        default:
            return <RetailerRoutes />;
    }
};


const PublicRoutes = () => {
    return (
        <IonReactRouter>
            <IonRouterOutlet>
                <Route path="/login" exact={true} component={LoginPage} />
                <Route path="/home" exact={true} component={WithoutLoginHomePage} />
                <Redirect  exact from="/"  to="/home" />
                <Route render={() => <Redirect to="/home" />} />
            </IonRouterOutlet>
        </IonReactRouter>
    );
};

const App = () => {
    const dispatch = useDispatch();
    const userSession = useSelector((state) => state.userSession);
    const {userInfo} = useSelector((state) => state.userAuthDetail);

    useEffect(() => {
        dispatch(actionToGetUserSessionData());
    }, []);

    return (
        <IonApp>
            {(!userSession?.loading) ?
                <React.Fragment>
                    {userInfo?.id ? <AppEnterMainPage/> : <PublicRoutes/>}
                </React.Fragment>:''
            }
            {(!userInfo?.id) &&
                <IonLoading className={"loading_loader_spinner_container"} isOpen={userSession?.loading} message={"Loading..."}/>
            }
        </IonApp>
    );
}
export default App;